import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/dealeri-verificati/")({
  head: () => routeHead("/uk/dealeri-verificati/"),
  beforeLoad: () => {
    throw redirect({ href: "/uk/verified-dealers", statusCode: 301, replace: true });
  },
});
